import * as R from "ramda";
import {GenericSequenceType} from "../../../common/Constants";

export const constructDataDetailUnitNOS = (data, controls) => {
    return data.filter(item => R.equals(item.saved, true)).map((item) => {
        return {
            kodeVarian: item.kodeVarian ? item.kodeVarian.value : null,
            frameNumber: item.frameNumber,
            engineNumber: item.engineNumber,
            kodeWarna: item.kodeWarna ? item.kodeWarna.value : null,
            rfsStatus: item.rfsStatus,
            yearManufactured: item.yearManufactured,
            kodeLocation: item.kodeLocation ? item.kodeLocation.value : null,
            kodeCabang: controls.kodeCabang.value.value,
            numberOfPrint: item.numberOfPrint || 0,
            spbmNo: item.spbmNo ? item.spbmNo : ""
        }
    });
}

export const constructToQRReport = (data, controls) => {
    return data.filter(item => R.equals(item.saved, true)).map((item) => {
        return {
            encryptedBarcode: item.encryptedBarcode,
            noSPBM: item.spbmNo ? item.spbmNo : "",
            spbmDate: controls.spbmDate.value,
            noSL: controls.slNo.value,
            slDate: controls.slDate.value,
            variantCode: item.kodeVarian ? item.kodeVarian.value : null,
            color: item.kodeWarna ? item.kodeWarna.label : null,
            buildYear: item.yearManufactured.toString(),
            noFrame: item.frameNumber,
            noEngine: item.engineNumber,
        }
    });
}

export const validateDataDetailUnitNOS = (list) => {
    const errors = [];

    const fieldsToValidate = ['frameNumber', 'engineNumber', 'kodeWarna', 'kodeVarian', 'kodeLocation'];

    list.forEach((obj, index) => {
        const objErrors = {};

        fieldsToValidate.forEach((field) => {
            const value = obj[field];
            if (value === null || value === undefined || value === '') {
                objErrors[field] = `${field} cannot be empty or null`;
            }

            if (field === 'frameNumber' || field === 'engineNumber') {
                if (value && value.length > 25) {
                    objErrors[field] = `${field} cannot exceed 25 characters`;
                }
            }
        });

        const year = obj["yearManufactured"];
        if (!R.isNil(year)) {
            if (!/^[0-9]{4}$/.test(year)) {
                objErrors['yearManufactured'] = 'yearManufactured must be a 4-digit number';
            }
        }

        if (Object.keys(objErrors).length > 0) {
            errors.push({ index, errors: objErrors });
        }
    });

    return !errors.length > 0;
};

export const getSupplierExpOptions = (data) => {
    return data.map((item) => {
        return {
            value: item.supplierCode,
            label: item.supplierName,
            name: item.supplierName,
        }
    })
}

export const constructGenSeqPayload = (kodeCabang) => {
    return {
        seqType: GenericSequenceType.RECEIVING_UNIT_NOS,
        nosDealerCode: kodeCabang.value,
        transactionType: GenericSequenceType.RECEIVING_UNIT_NOS,
    }
}